export const PACKAGE_GROUP_GYLDENDAL = "gyldendal";
export const PACKAGE_GROUP_ORDBOGEN = "ordbogen";
